import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectMaintenanceModeSettings } from '@app/core/store/ui-values-slice-selectors';
import { calculateTimeDifferenceInHours } from '@app/shared/helpers/maintenance/date-time-calculations';
import { useEffect, useState } from 'react';

export const useMaintenanceMode = () => {
  const settings = useAppSelector(selectMaintenanceModeSettings);
  const [now, setNow] = useState(new Date());
  const displayBannerPreHours = 1;
  const displayCardPreHours = 24;

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const hasDates = settings.start != null && settings.end != null;
  if (!hasDates) {
    return { renderBanner: false, renderCard: false };
  }

  const start = new Date(settings.start!);
  const end = new Date(settings.end!);

  const beforeStart = now < start;
  const beforeEnd = now < end;

  const hoursToStart = calculateTimeDifferenceInHours(now, start);

  const inCardWarning = beforeStart && hoursToStart <= displayCardPreHours;
  const inBannerWarning = beforeStart && hoursToStart <= displayBannerPreHours;
  const duringMaintenance = !beforeStart && beforeEnd;

  const renderBanner = inBannerWarning || duringMaintenance;
  const renderCard = inCardWarning;

  return { renderBanner, renderCard };
};
